module.exports = __webpack_public_path__ + "static/media/doc-icon.d8c0dfa2.svg";